export const FileUrl = {
    PAYABLE_XLSX_TEMPLATE:
        "https://bankme-attachments-hmg-01.s3.amazonaws.com/templates/EnvioDeTitulosDuplicataNotaPromissoria.xlsx",
    CHECK_XLSX_TEMPLATE: "https://bankme-attachments-hmg-01.s3.amazonaws.com/templates/EnvioDeTitulosCheque.xlsx",
};
